import React from 'react';

export const separationPayDetailsDescription = (
  <p>
    We’re required by law to reduce or withhold some of your VA compensation pay
    if you also receive disability severance pay.
  </p>
);
